// removed by extract-text-webpack-plugin
module.exports = {"icon":"AppIcon__icon___2dQBA","icon-wrapper":"AppIcon__icon-wrapper___tFfW9"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/AppCard/AppIcon.scss
// module id = 525
// module chunks = 0